const logger = console

export const error = logger.error
export const warn = logger.warn
export const info = logger.info
export const debug = logger.log
